
// import sweetalert2
import 'sweetalert2/dist/sweetalert2.min.css'
// import bootstrap
import 'bootstrap/dist/css/bootstrap.css'

import { defaultColor } from '@/constants/config'
/*  if you want use single color theme

- ColorSwitcher component remove in 'src/App.vue' file.
- Remove multicolor section in current file
- Uncomment the two lines below

import "./assets/css/sass/themes/sba.light.orange.scss";
import "./main";
*/

/* if you want single color remove this section:multicolor */
var color = defaultColor

let render = () => {
    import('./assets/css/sass/themes/sba.' + color + '.scss').then(x => require('./main'))
}

render()
/* if you want single color remove this section:multicolor */
